import { render, staticRenderFns } from "./push-button.vue?vue&type=template&id=11aa5282&scoped=true&"
import script from "./push-button.js?vue&type=script&lang=js&"
export * from "./push-button.js?vue&type=script&lang=js&"
import style0 from "./push-button.css?vue&type=style&index=0&id=11aa5282&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11aa5282",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VBadge})
